<template>
  <div>
    <!--  BEGIN NAVBAR  -->
    <Header></Header>
    <!--  END NAVBAR  -->

    <!--  BEGIN MAIN CONTAINER  -->
    <div
      class="main-container"
      id="container"
      :class="[!$store.state.is_show_sidebar ? 'sidebar-closed sbar-open' : '', $store.state.menu_style === 'collapsible-vertical' ? 'collapsible-vertical-mobile' : '']"
      style="height: 100vh; background: #0d1116"
    >
      <!--  BEGIN OVERLAY  -->
      <div class="overlay" :class="{ show: !$store.state.is_show_sidebar }" @click="$store.commit('toggleSideBar', !$store.state.is_show_sidebar)"></div>
      <div class="search-overlay" :class="{ show: $store.state.is_show_search }" @click="$store.commit('toggleSearch', !$store.state.is_show_search)"></div>
      <!-- END OVERLAY -->

      <!--  BEGIN SIDEBAR  -->
      <Sidebar></Sidebar>
      <!--  END SIDEBAR  -->

      <!--  BEGIN CONTENT AREA  -->
      <div id="content" class="main-content">
        <perfect-scrollbar class="content-wrapper" tag="ul" :options="{ wheelSpeed: 0.5, swipeEasing: !0, minScrollbarLength: 40, maxScrollbarLength: 300, suppressScrollX: true }">
          <router-view v-if="isShow">
            <!-- BEGIN LOADER -->
            <div id="load_screen">
              <div class="loader">
                <div class="loader-content">
                  <div class="spinner-grow align-self-center"></div>
                </div>
              </div>
            </div>
            <!--  END LOADER -->
          </router-view>

          <!-- BEGIN FOOTER -->
          <Footer></Footer>
          <!-- END FOOTER -->
        </perfect-scrollbar>
      </div>
      <!--  END CONTENT AREA  -->

      <!-- BEGIN APP SETTING LAUNCHER -->
      <app-settings />
      <!-- END APP SETTING LAUNCHER -->
    </div>
  </div>
</template>
<script>
import Header from '@/components/layout/header.vue';
import Sidebar from '@/components/layout/sidebar.vue';
import Footer from '@/components/layout/footer.vue';
import appSettings from '@/components/app-settings.vue';
import { mapActions } from 'vuex';
export default {
  components: {
    Header,
    Sidebar,
    Footer,
    appSettings,
  },
  data() {
    return {
      isShow: true,
    };
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  created() {
    // this.setAccountAsync();
    // this.setMenuAsync();
    // this.setnoticePageAsync();
    // window.setInterval(() => {
    //   this.setnoticePageAsync();
    // }, 60000 * 5);
  },
  methods: {
    ...mapActions({
      setAccountAsync: 'accountInfo/setAccountAsync',
      setMenuAsync: 'accountInfo/setMenuAsync',
      // setnoticePageAsync: 'notice/setnoticePageAsync',
    }),
    reload() {
      // 先隐藏
      this.isShow = false;

      // $nextTick() 将回调延迟到下次 DOM 更新循环之后执行
      this.$nextTick(() => {
        this.isShow = true;
      });
    },
  },
  mounted() {
    // console.log(this.$store.state)
    // console.log(this.$store.commit({ a: 1, b: 2 }));
  },
};
</script>

<style lang="scss" scoped>
#content {
  height: calc(100vh - 64px);
  margin-left: 224px;
  margin-top: 64px !important;
  overflow: hidden;
}
.content-wrapper {
  height: 100%;
  padding: 0 30px;
}
.collapsible-vertical .sidebar-closed > #content {
  margin-left: 36px;
}
.el-form-item {
  display: flex;
  justify-content: center;
}
</style>